import React from "react";
import { Link } from "react-router";

const InternalError: React.FC = () => {
  return (
    <div className="flex flex-col justify-center items-center p-5 text-center">
      <h1 className="text-4xl font-medium text-[#1C1790] mb-4">
        Internal Error
      </h1>
      <p className="text-xl mb-2">Cette page ne fonctionne pas.</p>
      <p className="text-base text-gray-600">
        Impossible de traiter cette demande pour le moment. Veuillez prendre
        contact avec votre administrateur si vous pensez que c'est une erreur.
      </p>
      <Link
        to="/"
        className="inline-block mt-4 px-6 py-3 bg-[#1C1790] text-white rounded hover:bg-[#1C1790] transition-colors"
      >
        Retourner à l'accueil
      </Link>
    </div>
  );
};

export default InternalError;
